<template>
<div
  v-if="animalsSelectionIsAvailable"
  :class="{ 'pb-4': animalsSelectionIsAvailable }"
>
    <div class="d-flex feature-animals justify-space-between px-0">
        <div class="d-flex body-2 p-0">
          <div class="mr-2">
            <VIcon :class="!animalsSelectionIsAvailable && 'disabled-text'">
              {{ icon }}
            </VIcon>
          </div>
          <div>
            <div>
              <span class="body-1" :class="!animalsSelectionIsAvailable && 'disabled-text'">{{ $t(name) }}</span>
            </div>
          </div>
        </div>
      <VSpacer />
      <VSwitch
        :input-value="animalsTransportation"
        :disabled="!animalsSelectionIsAvailable"
        class="pt-0 pb-0 mt-0"
        inset
        @change="updateValue"
      >
      </VSwitch>
    </div>
    <div
      v-if="!animalsSelectionIsAvailable"
      class="d-flex pb-4"
      :class="!isBookingFormNarrow && 'pl-8'"
    >
      <div>
        <span class="caption">{{ $t('features.animalsHint') }}</span>
      </div>
    </div>
</div>
</template>

<script lang="ts">
export default {
  name: 'FeatureAnimalsItem',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import RideTypeEnum from '@slg/web-customer-shared/src/enum/RideTypeEnum';
import { useVuetify } from '../../../composables';

const props = defineProps({
  icon: {
    type: String,
    default: 'mdi-paw',
  },
  name: {
    type: String,
    default: 'features.animals',
  },
  animalsTransportation: {
    type: Boolean,
    default: false,
  },
  rideType: {
    type: String,
    default: null,
  },
  dataTest: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['setAnimalsTransportation']);
const vuetify = useVuetify();

const animalsSelectionIsAvailable = computed(() => props.rideType === RideTypeEnum.PRIVATE);
const isBookingFormNarrow = computed(() => vuetify?.breakpoint.smAndDown);

function updateValue(newValue: boolean) {
  emit('setAnimalsTransportation', newValue);
}
</script>
<style lang="scss" scoped>
.feature-animals {
  height: 28px;

  .feature-logo {
    width: 24px;
    height: 24px;
    opacity: 0;

    &--show {
      opacity: 1;
    }
  }
}

.disabled-text {
  color: rgba(0, 0, 0, 0.38);
}
</style>
